import axios, { AxiosInstance, InternalAxiosRequestConfig } from 'axios';
import { getRuntimeConfig } from '../config/runtimeConfig';

export function getApiBaseUrl(): string {
  return getRuntimeConfig().apiUrl;
}

// Create axios instance — baseURL set per-request from runtime config
export const apiClient: AxiosInstance = axios.create({
  baseURL: '',
  timeout: 45_000,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Token getter function - will be set by auth provider
let getAccessToken: (() => string | null) | null = null;
let onUnauthorized: (() => void) | null = null;

export function setTokenGetter(getter: (() => string | null)) {
  getAccessToken = getter;
}

export function setUnauthorizedHandler(handler: (() => void) | null) {
  onUnauthorized = handler;
}

/** Bearer token for non-axios calls (e.g. multipart `fetch`) that must stay auth-consistent with `apiClient`. */
export function getAccessTokenForApi(): string | null {
  return getAccessToken?.() ?? null;
}

// Request interceptor to add auth token and runtime base URL
apiClient.interceptors.request.use(
  (config: InternalAxiosRequestConfig) => {
    config.baseURL = getApiBaseUrl();
    const token = getAccessToken?.();
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  error => Promise.reject(error)
);

// Response interceptor for error handling
apiClient.interceptors.response.use(
  response => response,
  error => {
    if (error.response?.status === 401) {
      console.warn('Unauthorized request - clearing session');
      onUnauthorized?.();
    }
    return Promise.reject(error);
  }
);
